app
  .controller("donationFormController", [
    "$scope",
    "StripePaymentFactory",
    "$localStorage",
    function ($scope, StripePaymentFactory, $localStorage) {
        let microsite = JSON.parse($localStorage.microsite);
        let siteConfig = microsite.microsite;

        if ($scope.payload.donationAmounts != undefined && $scope.payload.donationAmounts.length != 0) {
          $scope.amounts = $scope.payload.donationAmounts;
        } else {
          $scope.amounts = [5, 20, 50];
        }

        $scope.donate = function (amount) {
            $("#donationAmount").html(amount);
            $("#donateother").val(amount);
            $scope.donationAmount = amount;
      
            for (var i = 0; i < $scope.amounts.length; i++) {
              if (amount == $scope.amounts[i]) {
                $(`#donate-${i}`).addClass("btn-default");
                $(`#donate-${i}`).removeClass("btn-outline-default");
              } else {
                $(`#donate-${i}`).removeClass("btn-default");
                $(`#donate-${i}`).addClass("btn-outline-default");
              }
            }
          };
      
          $("#donateother").on("focus", function () {
            for (var i = 0; i < $scope.amounts.length; i++) {
              $(`#donate-${i}`).removeClass("btn-default");
              $(`#donate-${i}`).addClass("btn-outline-default");
            }
      
            $scope.donationAmount = $("#donateother").val();
          });
      
          $scope.keysSet = true;
          initStripe();
    
          function initStripe() {
            if (siteConfig.stripePaymentType == "connect") {
              StripePaymentFactory.stripeConnectToken().then(function (stripeToken) {
                initStripeResult(stripeToken);
              });
            } else {
              StripePaymentFactory.stripeIntentKey().then(function (stripeToken) {
                initStripeResult(stripeToken);
              });
            }
          }
          function initStripeResult(stripeToken) {
            if (stripeToken != false) {
              $("#payBtn").prop("disabled", false);
              initStripeForm(stripeToken);
            } else {
              $scope.keysSet = false;
            }
          }
      
          function initStripeForm(stripeToken, stripeType) {
            var stripe = Stripe(stripeToken);
            var elements = stripe.elements();
      
            var card = elements.create("card", {
              hidePostalCode: true,
              iconStyle: "solid",
              style: {
                base: {
                  iconColor: "#8898AA",
                  color: "#333333",
                  lineHeight: "36px",
                  fontWeight: 300,
                  fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                  fontSize: "19px",
      
                  "::placeholder": {
                    color: "#8898AA",
                  },
                },
                invalid: {
                  iconColor: "#e85746",
                  color: "#e85746",
                },
              },
              classes: {
                focus: "is-focused",
                empty: "is-empty",
              },
            });
            card.mount("#card-element");
      
            var inputs = document.querySelectorAll("input.field");
            Array.prototype.forEach.call(inputs, function (input) {
              input.addEventListener("focus", function () {
                input.classList.add("is-focused");
              });
              input.addEventListener("blur", function () {
                input.classList.remove("is-focused");
              });
              input.addEventListener("keyup", function () {
                if (input.value.length === 0) {
                  input.classList.add("is-empty");
                } else {
                  input.classList.remove("is-empty");
                }
              });
            });
      
            document
              .getElementById("stripePayForm")
              .addEventListener("submit", function (e) {
                if ($localStorage.email == null || $localStorage.email == "" || $localStorage.shopUserID == null || $localStorage.shopUserID == "") {
                  toastr.error("Failed to process payment! Please refresh your browser and try again.");
                  return false;
                }
      
                $("#payBtn").prop("disabled", true);
                e.preventDefault();
      
                var stripeValue = parseFloat($("#donateother").val()) * 100;
                var description = `Donation by ${$localStorage.name} ${$localStorage.surname} email: ${$localStorage.email} ID: ${$localStorage.shopUserID}`;
      
                let postdata = {
                  total: stripeValue,
                  currency: siteConfig.currency,
                  cart: JSON.stringify([
                    {
                      item: "donation",
                      price: stripeValue,
                      currency: siteConfig.currency,
                    },
                  ]),
                  email: $localStorage.email,
                  shopUserID: $localStorage.shopUserID,
                  description: description
                };
                
                stripePayment(postdata, stripeValue, description, card, stripe);
              });
          }
      
          function stripePayment(postdata, stripeValue, description, card, stripe) {
            if (siteConfig.stripePaymentType == "connect") {
              StripePaymentFactory.stripeConnectIntent(postdata).then(function (clientSecret) {
                stripePaymentResult(clientSecret, stripeValue, description, card, stripe);
              });
            } else {
              StripePaymentFactory.stripeIntentIntent(postdata).then(function (clientSecret) {
                stripePaymentResult(clientSecret, stripeValue, description, card, stripe);
              });
            }
          }
          function stripePaymentResult(clientSecret, stripeValue, description, card, stripe) {
            if (clientSecret != false) {
              stripe
                .confirmCardPayment(clientSecret, {
                  payment_method: {
                    card: card,
                    billing_details: {
                      name: `${$localStorage.name} ${$localStorage.surname}`,
                      email: $localStorage.email,
                    },
                  },
                })
                .then(function (result) {
                  if (result.error) {
                    $("#payBtn").prop("disabled", false);
                    toastr.error(result.error.message);
                  } else {
                    // The payment has been processed!
                    if (result.paymentIntent.status === "succeeded") {
                      let postdata = {
                        cart: JSON.stringify([
                          {
                            item: "donation",
                            // used in email, not stripe
                            price: (stripeValue / 100).toString() + ".00",
                            currency: siteConfig.currency,
                          },
                        ]),
                        piID: result.paymentIntent.id,
                      };
    
                      if (siteConfig.stripePaymentType == "connect") {
                        StripePaymentFactory.recordStripeConnectPayment(postdata);
                      } else {
                        StripePaymentFactory.fulfillPaymentIntent(postdata);
                      }
    
                      toastr.success("Payment suceeded! Thank you for your donation.");
                      card.clear();
                      $("#thanksArea").show();
                    }
                    $("#payBtn").prop("disabled", false);
                  }
                });
            } else {
              toastr.error("Payment failed, could not create payment intent.");
            }
          }
      
    },
  ]);
